import { apiGet, apiPost, apiPatch, apiDelete } from "utils/apiClient";

export interface LiquidityPool {
    _id: string;
    username: string;
    name: string;
    currency: string;
    currentBalance: number;
    createdAt: string;
    updatedAt: string;
}

export interface Transfer {
    _id: string;
    username: string;
    sourcePoolId: string;
    targetPoolId: string;
    amount: number;
    currency: string;
    date: string;
    createdAt: string;
}

export interface Exchange {
    _id: string;
    username: string;
    sourcePoolId: string;
    targetPoolId: string;
    sourceAmount: number;
    targetAmount: number;
    rate: number;
    sourceCurrency: string;
    targetCurrency: string;
    date: string;
    createdAt: string;
}

const base = (username: string) => `/wallet/${username}`;

export async function getPools(username: string): Promise<LiquidityPool[]> {
    const res = await apiGet<LiquidityPool[]>(`${base(username)}/pools`);
    return Array.isArray(res) ? res : [];
}

export async function createPool(
    username: string,
    data: { name: string; currency: string; initialBalance?: number }
): Promise<LiquidityPool | { message?: string }> {
    return apiPost<LiquidityPool | { message?: string }>(`${base(username)}/pools`, data);
}

export async function updatePool(
    username: string,
    poolId: string,
    data: { name?: string; currency?: string }
): Promise<LiquidityPool | { message?: string }> {
    return apiPatch<LiquidityPool | { message?: string }>(`${base(username)}/pools/${poolId}`, data);
}

export async function deletePool(
    username: string,
    poolId: string
): Promise<{ message?: string }> {
    return apiDelete<{ message?: string }>(`${base(username)}/pools/${poolId}`);
}

export async function transfer(
    username: string,
    data: { sourcePoolId: string; targetPoolId: string; amount: number }
): Promise<Transfer | { message?: string }> {
    return apiPost<Transfer | { message?: string }>(`${base(username)}/transfer`, data);
}

export async function exchange(
    username: string,
    data: {
        sourcePoolId: string;
        targetPoolId: string;
        sourceAmount: number;
        rate: number;
        rateMultiplies: boolean;
    }
): Promise<Exchange | { message?: string }> {
    return apiPost<Exchange | { message?: string }>(`${base(username)}/exchange`, data);
}
